import { z } from "zod";

export const getContactBankAccountSchema = z.object({
	contactId: z.string().nonempty(),
	bankAccountId: z.string().nonempty(),
});

export type GetContactBankAccountSchema = z.infer<typeof getContactBankAccountSchema>;
